module.exports = __webpack_public_path__ + "static/PatKT-09-52a479fb4e39495de927560a3702e1f0.jpg";